@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field class='pb-4'>
      @if (inputService.formInputDefinition.remoteOptions.icon) {
        <mat-icon matPrefix class='mr-4'>{{inputService.formInputDefinition.remoteOptions.icon}}</mat-icon>
      }
      <mat-label>
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      <mat-chip-grid #chipList>
        @for (item of selectedItems; track item) {
          <mat-chip-row
            [selectable]="true"
            [removable]="true"
            (removed)="removeItem(item)"
            >
            {{ displayFun(item) }}
            @if (true) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip-row>
        }
        <input
          [required]='inputService.inputConfig.required'
          [placeholder]="(inputService.inputConfig.placeholder || '') | translate"
          autocomplete="off"
          [name]='inputService.formControlKey'
          #filterInput
          (input)="fetchFilteredOptions($event.target.value)"
          [formControl]='inputFormControl'
          [readonly]='inputService.inputConfig.readOnly'
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="onMatChipInputTokenEnd($event)"
          />
        @if (loading) {
          <mat-spinner diameter="15" matSuffix></mat-spinner>
        }
      </mat-chip-grid>
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint}}</mat-hint>
      }
      @if (!inputService.control.valid) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
      <input type='hidden' [formControlName]='inputService.formControlKey' />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)='onMatAutocompleteSelectedEvent($event)'>
        @if (supportCreate && textSearch) {
          <mat-option [value]="textSearch">
            <mat-icon>add</mat-icon>
            <span>{{'Crea' | translate}}: {{textSearch}}</span>
          </mat-option>
        }
        @for (option of filteredOptions | async; track trackByOptions($index, option)) {
          <mat-option [value]="option">
            @if (inputService.formInputDefinition.remoteOptions.icon) {
              <mat-icon>{{inputService.formInputDefinition.remoteOptions.icon}}</mat-icon>
            }
            <span [innerHTML]='inputService.formInputDefinition.remoteOptions.getLabel(option)'></span>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </ng-container>
}